"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("./Card"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Deck = _styledComponents.default.div.withConfig({
  displayName: "Deck",
  componentId: "gcfvq7-0"
})(["display:flex;flex-wrap:wrap;justify-content:stretch;margin:0 Calc(-", " / 2);", "{flex:1 0 250px;margin:0 8px 16px;padding:", ";margin:0 Calc(", " / 2) ", ";}"], function (_ref) {
  var _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 'medium' : _ref$spacing;
  return (0, _helpers.getSpacing)(spacing);
}, _Card.default, function (_ref2) {
  var _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 'medium' : _ref2$spacing;
  return (0, _helpers.getSpacing)(spacing);
}, function (_ref3) {
  var _ref3$spacing = _ref3.spacing,
      spacing = _ref3$spacing === void 0 ? 'medium' : _ref3$spacing;
  return (0, _helpers.getSpacing)(spacing);
}, function (_ref4) {
  var _ref4$spacing = _ref4.spacing,
      spacing = _ref4$spacing === void 0 ? 'medium' : _ref4$spacing;
  return (0, _helpers.getSpacing)(spacing);
});

var _default = Deck;
exports.default = _default;